import React from "react";
import PropTypes from "prop-types";
import { EXTENSION_PAGE } from "../../../shared/extension-preview.js";
import CheckoutEditorPreview from "./checkout/CheckoutEditorPreview";
import ThankYouEditorPreview from "./thank-you/ThankYouEditorPreview";
import OrderStatusEditorPreview from "./order-status/OrderStatusEditorPreview";
import CartDrawerEditorPreview from "./cart-drawer/CartDrawerEditorPreview";

const SURFACE_PREVIEW_COMPONENTS = Object.freeze({
  [EXTENSION_PAGE.CHECKOUT]: CheckoutEditorPreview,
  [EXTENSION_PAGE.THANK_YOU_PAGE]: ThankYouEditorPreview,
  [EXTENSION_PAGE.ORDER_STATUS_PAGE]: OrderStatusEditorPreview,
  [EXTENSION_PAGE.CART_DRAWER]: CartDrawerEditorPreview,
});

export default function ExtensionSurfaceEditorPreview({
  surface,
  popupData,
  popupState,
  setPopupState,
}) {
  const PreviewComponent = SURFACE_PREVIEW_COMPONENTS[surface];
  if (!PreviewComponent) return null;

  return (
    <PreviewComponent
      popupData={popupData}
      popupState={popupState}
      setPopupState={setPopupState}
    />
  );
}

ExtensionSurfaceEditorPreview.propTypes = {
  surface: PropTypes.string.isRequired,
  popupData: PropTypes.object,
  popupState: PropTypes.object,
  setPopupState: PropTypes.func,
};
